import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useUserBelongsToCurrentClub_session$key } from "./__generated__/useUserBelongsToCurrentClub_session.graphql";

export const useUserBelongsToCurrentClub = (
  sessionRef: useUserBelongsToCurrentClub_session$key | null
) => {
  const session = useFragment(
    useUserBelongsToCurrentClubFragmentString,
    sessionRef
  );

  return !!session?.currentClientProfile?.member?.id;
};

const useUserBelongsToCurrentClubFragmentString = graphql`
  fragment useUserBelongsToCurrentClub_session on Session {
    currentClientProfile {
      member {
        ... on Customer {
          id
        }
        ... on Member {
          id
        }
      }
    }
  }
`;
